import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import logoHere from "./../../public/images/logo.png";
import logoHere2 from "./../../public/images/logoWhiteLabel.png";
import "./../../public/scss/generic.scss";
import PropTypes from "prop-types";
import {
  switchToWhiteLabelView,
  doLogin,
  getSiblings,
  getAllAccounts,
  loginUser,
  loginEmTeacher,
} from "./../../actions/feedActions";
import { connect } from "react-redux";
import { imageLink, isMobileBrowser, validateIfTeacher } from "./../../actions/utility";
import emptyUserImg2 from "../../public/images/empty.svg";

import Switch from "react-switch";

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  NavbarText,
  Nav,
  NavItem,
  Button,
  Media,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Input,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "reactstrap";
import { faYenSign } from "@fortawesome/free-solid-svg-icons";
import {
  getToken,
  sendOTPForPassword,
  updatePassword,
  verifyOTPForPassword,
} from "../../actions/emActions";

class HeaderComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      logoImage: window.location.host != "feeds.lincolnmethod.com" ? logoHere2 : logoHere,
      // logoImage: this.props.whiteLabel == true ? logoHere2 : logoHere,
      studentName: "Haseeb Patel",
      isTuitionsPostType: this.props.whiteLabel ? false : true,
      showLoginModal: false,
      email: "",
      password: "",
      credError: "",
      isTeacherLoggedIn: false,
      isEmLoggedIn: false,
      loginType: "",
      emName: "",
      imageName: "",
      loginLoader: false,
      multipleRole: false,
      switchRoute: true,
      toggle: false,
      userAccounts: [],
      activeView: 1,
      loginUserName: "",
      loginError: false,
      otpCode: "",
      newPassowrd: "",
      reTypePassword: "",
      copied: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.logout = this.logout.bind(this);
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  componentWillReceiveProps(nextProps, thisProps) {
    if (this.props.headerData != nextProps.headerData) {
      this.setState({
        studentName: nextProps.headerData.studentName,
      });
    }

    // for login response
    if (
      typeof nextProps.loginSuccessNormal === "object" &&
      nextProps.loginSuccessNormal.status == "error" &&
      nextProps.loginSuccessNormal.message &&
      nextProps.loginSuccessNormal.message.length
    ) {
      // showing here the incorrect credentials msg
      this.setState({
        loginLoader: false,
        credError: nextProps.loginSuccessNormal.message,
        loginError: true,
      });
    } else if (
      typeof nextProps.loginSuccessNormal === "object" &&
      nextProps.loginSuccessNormal.status == "success"
    ) {
      console.log("login has been succcessfull");
      try {
        var tempData = nextProps.loginSuccessNormal;
        var isTeacher = tempData.is_teacher;
        debugger;
        if (isTeacher && isTeacher == 1) {
          this.setState(
            {
              showLoginModal: false,
            },
            () => {
              localStorage.setItem("loginData", JSON.stringify(nextProps.loginSuccessNormal));
              window.location.reload();
              // console.log(tempData);
            }
          );
        } else {
          this.setState({
            showLoginModal: false,
          });
          localStorage.setItem("loginData", JSON.stringify(nextProps.loginSuccessNormal));
          // window.location.reload();
          var userType = JSON.parse(localStorage.getItem("loginUserInfo"));
          getToken(nextProps.loginSuccessNormal.user.user_id).then((res) => {
            localStorage.setItem("loginToken", res.data.accessToken);
            debugger;
            if (userType.user_type === 1) {
              this.props.history.push("/Teacherdashboard");
              window.location.reload();
            } else if (userType.user_type === 6) {
              this.props.history.push("/dashboard");
              window.location.reload();
            }
          });
        }
      } catch (err) {
        console.log("loginData could not store:", err);
      }
    }
  }

  onToggleSwitch = () => {
    this.setState(
      {
        isTuitionsPostType: !this.state.isTuitionsPostType,
      },
      () => {
        if (this.state.isTuitionsPostType) {
          this.props.switchToWhiteLabelView("tuitions");
        } else {
          this.props.switchToWhiteLabelView("dashboard");
        }
      }
    );
  };

  componentDidMount() {
    var showModal = window.location.hash.split("#/")[1] == "" ? true : false;
    // localStorage.clear();

    // if(!this.props.whiteLabel){
    //   this.onToggleSwitch();
    // }
    try {
      var loginStatus = localStorage.getItem("loginData");

      if (loginStatus != null && typeof JSON.parse(loginStatus) === "object") {
        this.setState({
          showLoginModal: false,
          isTeacherLoggedIn: validateIfTeacher() ? true : false, // if teacher is logged in not student
          emName: JSON.parse(loginStatus).user.user_name,
          loginType: JSON.parse(loginStatus).user_type,
          multipleRole: JSON.parse(loginStatus).is_em,
          imageName: JSON.parse(loginStatus).user.image,
        });
      } else {
        this.setState({
          showLoginModal: showModal,
        });
      }
    } catch (err) {
      this.setState({
        showLoginModal: showModal,
      });
    }

    getSiblings("user_email");
  }

  toggleModal() {
    this.setState({
      showLoginModal: !this.state.showLoginModal,
    });
  }

  logout() {
    localStorage.removeItem("loginData");
    this.props.history.push("/");
    // window.location.reload();
  }

  loginUserFunc = () => {
    if (this.state.loginUserInfo.user_type === 2) {
      debugger;
      this.props
        .loginUser(this.state.loginUserInfo.user_loginname, this.state.password)
        .then((res) => {
          debugger;
          if (res.data.status === "success") {
            localStorage.setItem("loginData", JSON.stringify(res.data.result));
            localStorage.setItem("loginUserInfo", JSON.stringify(this.state.loginUserInfo));
            this.props.history.push(`/${res.data.result.user.id}`);
          } else {
            this.setState({
              loginError: true,
            });
          }
        });
    } else if (this.state.loginUserInfo.user_type === 1) {
      debugger;
      this.props.doLogin(
        this.state.loginUserInfo.user_loginname,
        this.state.password,
        this.state.loginUserInfo.user_type
      );
      localStorage.setItem("userEmail", this.state.loginUserInfo.user_loginname);
      localStorage.setItem("userPassword", this.state.password);
      localStorage.setItem("loginUserInfo", JSON.stringify(this.state.loginUserInfo));
      // .then((res) => {
      //   localStorage.setItem("loginData", JSON.stringify(res.data));
      //   this.props.history.push("/Teacherdashboard");
      // });
    } else if (this.state.loginUserInfo.user_type === 6) {
      debugger;
      this.props.doLogin(
        this.state.loginUserInfo.user_loginname,
        this.state.password,
        this.state.loginUserInfo.user_type
      );
      localStorage.setItem("userEmail", this.state.loginUserInfo.user_loginname);
      localStorage.setItem("userPassword", this.state.password);
      localStorage.setItem("loginUserInfo", JSON.stringify(this.state.loginUserInfo));
      // .then((res) => {
      //   localStorage.setItem("loginData", JSON.stringify(res.data));
      //   this.props.history.push("/dashboard");
      // });
    }
  };

  sendOtpFunc = () => {
    sendOTPForPassword(
      this.state.loginUserInfo.user_email,
      this.state.loginUserInfo.user_loginname
    ).then((res) => {
      this.setState({ activeView: 4 });
      debugger;
    });
  };

  verifyOtpFunc = () => {
    this.setState({ loginError: false });
    verifyOTPForPassword(
      this.state.loginUserInfo.user_email,
      this.state.loginUserInfo.user_loginname,
      this.state.otpCode
    ).then((res) => {
      debugger;
      if (res.status === 201) {
        this.setState({ activeView: 5 });
      } else if (res.status === 401) {
        this.setState({ loginError: true });
        console.log("Invalid OTP");
      }
    });
  };

  updatePasswordFunc = () => {
    this.setState({ loginError: false });
    if (this.state.newPassowrd === this.state.reTypePassword) {
      debugger;
      updatePassword(this.state.newPassowrd).then((res) => {
        this.setState({ activeView: 3 });
      });
    } else {
      this.setState({ loginError: true });
    }
  };

  submitLoginForm = (event) => {
    const { email } = this.state;
    if (email != "") {
      if (true) {
        this.setState(
          {
            credError: "", // removing the error message
            // loginLoader: true,
          },
          () => {
            this.props
              .getAllAccounts(
                email,
                window.location.host === "feeds.lincolnmethod.com" ||
                  window.location.host === "localhost:3000" ||
                  window.location.host === "localhost:3001"
                  ? 2
                  : 2
              )
              .then((res) => {
                debugger;
                if (res.data.status === "success") {
                  if (res?.data?.result?.length > 0) {
                    this.setState({
                      activeView: 2,
                      userAccounts: res.data.result,
                    });
                  } else {
                    this.setState({
                      credError: "No Account Found",
                    });
                  }
                }
              });
          }
        );
      }
    } else {
      this.setState({
        loginLoader: false,
        credError: "Email/UserName and Password is required.",
      });
    }
  };

  componentWillUnmount() {}
  onEnterPress = (e) => {
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      this.loginUserFunc();
    }
  };
  switchtoEm = () => {
    this.setState({
      switchRoute: !this.state.switchRoute,
    });
    this.props.history.push("/teacherdashboard");
  };

  copyFunc = () => {
    navigator.clipboard.writeText(`https://lincolnmethod.com/?ref=${this.props.studentId}`);
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 2000);
  };
  render() {
    const { studentView = false } = this.props;
    var strArr = window.location.hash.split("#/");
    //console.log("Route String", strArr);
    const {
      loginType,
      activeView,
      userAccounts,
      email,
      loginUserName,
      loginUserImg,
      loginUserInfo,
    } = this.state;
    return (
      <div className="HeaderComponent" id="HeaderComponent">
        {/* Modal popup starts here */}
        <Modal isOpen={this.state.showLoginModal} size="lg" centered className="loginModal">
          {/* <ModalHeader className="modalMultiRole">Login:</ModalHeader> */}
          <ModalBody className="modalMultiRole" style={{ textAlign: "center" }}>
            {activeView === 1 ? (
              <Row className="justify-content-center">
                <Col md="6" className="mt-5">
                  <div className="">
                    <img className="mb-5 m-auto" src={logoHere} />
                  </div>
                  <div className="text-left">
                    <hr />
                    <FormGroup style={{ position: "relative" }}>
                      {this.state.credError && this.state.credError.length ? (
                        <p style={{ color: "red" }}>{this.state.credError}</p>
                      ) : null}
                      <label className="text-left">Email or Phone number</label>
                      <Input
                        type="text"
                        name="login_email"
                        id="login_email"
                        placeholder=""
                        onChange={(evt) => {
                          this.setState({ email: evt.target.value });
                        }}
                      />
                    </FormGroup>
                    <Button color="warning" onClick={this.submitLoginForm}>
                      Next
                    </Button>
                    {this.state.loginLoader ? (
                      <div class="spinner-border text-warning" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    ) : null}
                    {/* <FormGroup>
                    <label className="text-left">Password</label>
                    <Input
                      type="password"
                      name="password"
                      id="login_password"
                      placeholder=""
                      onChange={(evt) => {
                        this.setState({ password: evt.target.value });
                      }}
                      onKeyDown={this.onEnterPress}
                    />
                  </FormGroup> */}
                  </div>
                </Col>
              </Row>
            ) : activeView === 2 ? (
              <Row className="justify-content-center">
                <Col md="12">
                  <div className="text-left">
                    <h5 className="mb-5">Accounts registered for this {email}: </h5>
                  </div>
                </Col>
                {userAccounts &&
                  userAccounts.map((item) => (
                    <Col
                      md="3"
                      className="mb-3"
                      onClick={() =>
                        this.setState({
                          loginUserInfo: item,
                          activeView: 3,
                        })
                      }
                    >
                      <img
                        src={item.image !== null ? imageLink(item.image) : emptyUserImg2}
                        className=""
                        width="100"
                        height="100"
                      />
                      <br />
                      <label className="mb-0">{item.user_loginname}</label>

                      {item.user_type === 1 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Teacher
                        </span>
                      ) : item.user_type === 2 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Student
                        </span>
                      ) : item.user_type === 6 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          EM
                        </span>
                      ) : null}
                    </Col>
                  ))}
              </Row>
            ) : activeView === 3 ? (
              <Row className="justify-content-center">
                <Col md="12" className="text-left">
                  <i
                    onClick={(e) => this.setState({ activeView: 2 })}
                    className="fa fa-arrow-left"
                  ></i>
                </Col>
                <Col md="6" className="mt-5">
                  <div className="">
                    <img className="mb-5 m-auto" src={logoHere} />
                  </div>
                  <div className="text-left">
                    <hr />
                    <div className="text-center">
                      <img
                        src={
                          loginUserInfo?.image !== null
                            ? imageLink(loginUserInfo.image)
                            : emptyUserImg2
                        }
                        className=""
                        width="100"
                        height="100"
                      />
                      <br />
                      <label className="mb-0">{loginUserInfo?.user_name}</label>
                      {loginUserInfo?.user_type === 1 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Teacher
                        </span>
                      ) : loginUserInfo?.user_type === 2 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Student
                        </span>
                      ) : loginUserInfo?.user_type === 6 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          EM
                        </span>
                      ) : null}

                      {this.state.loginError && (
                        <label className="text-danger font-weight-bold">Invalid Credentials</label>
                      )}
                    </div>
                    <FormGroup style={{ position: "relative" }}></FormGroup>
                    <FormGroup>
                      <label className="text-left">Password:</label>
                      <Input
                        type="password"
                        name="password"
                        id="login_password"
                        placeholder=""
                        onChange={(evt) => {
                          this.setState({ password: evt.target.value });
                        }}
                        onKeyDown={this.onEnterPress}
                      />
                      <label className="mb-0 linkLabel text-primary" onClick={this.sendOtpFunc}>
                        Forgotten password?
                      </label>
                    </FormGroup>

                    <Button color="warning" onClick={this.loginUserFunc}>
                      Login
                    </Button>
                    {this.state.loginLoader ? (
                      <div class="spinner-border text-warning" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    ) : null}
                  </div>
                </Col>
              </Row>
            ) : activeView === 4 ? (
              <Row className="justify-content-center">
                <Col md="12" className="text-left">
                  <i
                    onClick={(e) => this.setState({ activeView: 2 })}
                    className="fa fa-arrow-left"
                  ></i>
                </Col>
                <Col md="6" className="mt-5">
                  <div className="">
                    <img className="mb-5 m-auto" src={logoHere} />
                  </div>
                  <div className="text-left">
                    <hr />
                    <div className="text-center">
                      <img
                        src={
                          loginUserInfo?.image !== null
                            ? imageLink(loginUserInfo.image)
                            : emptyUserImg2
                        }
                        className=""
                        width="100"
                        height="100"
                      />
                      <br />
                      <label className="mb-0">{loginUserInfo?.user_name}</label>
                      {loginUserInfo?.user_type === 1 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Teacher
                        </span>
                      ) : loginUserInfo?.user_type === 2 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Student
                        </span>
                      ) : loginUserInfo?.user_type === 6 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          EM
                        </span>
                      ) : null}

                      <label className="text-success">
                        We have sent you a verification code on your email:{" "}
                        {this.state.loginUserInfo.user_email}
                      </label>
                      <br />
                      {this.state.loginError && (
                        <label className="text-danger font-weight-bold">
                          Invalid verification code
                        </label>
                      )}
                    </div>
                    <FormGroup style={{ position: "relative" }}></FormGroup>
                    <FormGroup>
                      <label className="text-left">Enter code here:</label>
                      <Input
                        type="number"
                        name="password"
                        id="login_password"
                        placeholder=""
                        onChange={(evt) => {
                          this.setState({ otpCode: evt.target.value });
                        }}
                        onKeyDown={this.onEnterPress}
                      />
                    </FormGroup>

                    <Button color="warning" onClick={this.verifyOtpFunc}>
                      Verify
                    </Button>
                    {this.state.loginLoader ? (
                      <div class="spinner-border text-warning" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    ) : null}
                  </div>
                </Col>
              </Row>
            ) : (
              <Row className="justify-content-center">
                <Col md="12" className="text-left">
                  <i
                    onClick={(e) => this.setState({ activeView: 2 })}
                    className="fa fa-arrow-left"
                  ></i>
                </Col>
                <Col md="6" className="mt-5">
                  <div className="">
                    <img className="mb-5 m-auto" src={logoHere} />
                  </div>
                  <div className="text-left">
                    <hr />
                    <div className="text-center">
                      <img
                        src={
                          loginUserInfo?.image !== null
                            ? imageLink(loginUserInfo.image)
                            : emptyUserImg2
                        }
                        className=""
                        width="100"
                        height="100"
                      />
                      <br />
                      <label className="mb-0">{loginUserInfo?.user_name}</label>
                      {loginUserInfo?.user_type === 1 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Teacher
                        </span>
                      ) : loginUserInfo?.user_type === 2 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          Student
                        </span>
                      ) : loginUserInfo?.user_type === 6 ? (
                        <span style={{ fontFamily: "Caveat", fontSize: 14, display: "block" }}>
                          EM
                        </span>
                      ) : null}

                      {this.state.loginError && (
                        <label className="text-danger font-weight-bold">
                          Confirm password doesn't match New password
                        </label>
                      )}
                      <label className="text-success"></label>
                    </div>
                    <FormGroup style={{ position: "relative" }}></FormGroup>
                    <FormGroup>
                      <label className="text-left">New password:</label>
                      <Input
                        type="password"
                        placeholder=""
                        onChange={(evt) => {
                          this.setState({ newPassowrd: evt.target.value });
                        }}
                      />
                    </FormGroup>
                    <FormGroup>
                      <label className="text-left">Confirm password:</label>
                      <Input
                        type="password"
                        placeholder=""
                        onChange={(evt) => {
                          this.setState({ reTypePassword: evt.target.value });
                        }}
                      />
                    </FormGroup>

                    <Button color="warning" onClick={this.updatePasswordFunc}>
                      Update
                    </Button>
                    {this.state.loginLoader ? (
                      <div class="spinner-border text-warning" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    ) : null}
                  </div>
                </Col>
              </Row>
            )}
          </ModalBody>
          <ModalFooter className="modalMultiRole"></ModalFooter>
        </Modal>

        <Navbar color="" expand="md" style={{ background: "#343a40" }}>
          <NavbarBrand>
            <Media src={this.props.clientId === 3 ? logoHere2 : logoHere} height="40" />
          </NavbarBrand>
          {!studentView && isMobileBrowser() && (
            <button className="ml-2 btn btn-light btn-sm btn-rounded">
              <i className="fa fa-bars" onClick={this.toggle} />
            </button>
          )}
          {/* <NavbarToggler onClick={this.toggle} /> */}
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto text-left" navbar>
              {
                strArr[1] == "dashboard" || strArr[1] == "Teacherdashboard" ? (
                  <React.Fragment>
                    {/* {this.state.multipleRole ? (
                      <NavItem>
                        <NavbarText className="text-light font-weight-bold mt-2 switchforRole">
                          <Switch
                            checked={this.state.switchRoute}
                            onChange={this.switchtoEm}
                            uncheckedIcon={<div className="textForswitch">Education Mama</div>}
                            checkedIcon={<div className="textForswitchRight">Tutor</div>}
                            onHandleColor="#000"
                            className={
                              this.state.switchRoute
                                ? "highest react-switch medium"
                                : "lowest react-switch medium"
                            }
                            id="icon-switch"
                          />
                        </NavbarText>
                      </NavItem>
                    ) : null} */}
                    <NavItem>
                      <NavbarText className="text-light font-weight-bold mt-2 m-2">
                        {this.state.emName}
                        <sup style={{ marginLeft: 2, fontFamily: "Caveat", fontSize: 14 }}>
                          Education Mama
                        </sup>
                      </NavbarText>
                      {this.state.imageName !== null ? (
                        <img
                          src={`https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/${this.state.imageName}`}
                          alt="Avatar"
                          className="avatarStudent"
                        />
                      ) : (
                        <img
                          src={require("../../public/images/emptyuserphoto.png")}
                          alt="Avatar"
                          className="avatarStudent"
                        />
                      )}{" "}
                    </NavItem>
                  </React.Fragment>
                ) : studentView === false ? (
                  <div className="mr-3 mt-2">
                    <img
                      src={require("../../public/images/emptyuserphoto.png")}
                      alt="Avatar"
                      className="avatarStudent mr-2"
                    />
                    <label className="text-light">{this.state.emName}</label>
                  </div>
                ) : null
                // <NavbarText className="text-light font-weight-bold d-flex">
                //   <div className="mr-3">
                //     <Dropdown
                //       className=""
                //       isOpen={this.state.toggle}
                //       toggle={() => this.setState({ toggle: !this.state.toggle })}
                //     >
                //       <DropdownToggle tag="span">
                //         <img
                //           src={require("../../public/images/emptyuserphoto.png")}
                //           alt="Avatar"
                //           className="avatarStudent mr-2"
                //         />
                //         <label className="text-light">
                //           {this.state.emName} <i className="fa fa-chevron-down"></i>
                //         </label>
                //       </DropdownToggle>
                //       <DropdownMenu className="mt-3" container="body">
                //         <div className="headerDropdownSection">
                //           <Link to={`/${this.props.studentId}/invoices`}>
                //             <label>
                //               <i className="fa fa-pay"></i> Invoices
                //             </label>
                //           </Link>
                //         </div>
                //       </DropdownMenu>
                //     </Dropdown>
                //   </div>
                //   <div className="">
                //     <Button
                //       size="sm"
                //       style={{ backgroundColor: "#FED700", color: "black" }}
                //       onClick={this.logout}
                //       className="mt-1"
                //     >
                //       Logout
                //     </Button>
                //   </div>
                // </NavbarText>

                // <div className="mr-3">
                //   <Dropdown
                //     className="mt-2"
                //     isOpen={this.state.toggle}
                //     toggle={() => this.setState({ toggle: !this.state.toggle })}
                //   >
                //     <DropdownToggle tag="span">
                //       <img
                //         src={require("../../public/images/emptyuserphoto.png")}
                //         alt="Avatar"
                //         className="avatarStudent mr-2"
                //       />
                //       <label className="text-light">
                //         {this.state.emName} <i className="fa fa-chevron-down"></i>
                //       </label>
                //     </DropdownToggle>
                //     <DropdownMenu className="mt-3" container="body">
                //       <div className="headerDropdownSection">
                //         <label onClick={this.copyFunc}>
                //           <i className="fa fa-copy"></i> Share referral link
                //         </label>
                //       </div>
                //     </DropdownMenu>
                //   </Dropdown>
                // </div>
              }
              {/* {strArr[1] != "dashboard" && strArr[1] != "Teacherdashboard" ? (
                <NavbarText className="mb-4">
                  {this.state.showLoginModal ? null : (
                    <Switch
                      checked={!this.state.isTuitionsPostType}
                      onChange={() => this.onToggleSwitch()}
                      uncheckedIcon={<div className="switchLabel">Tuitions</div>}
                      checkedIcon={<div className="switchLabel">Self learning</div>}
                      className={
                        this.state.isTuitionsPostType
                          ? "highest react-switch medium"
                          : "lowest react-switch medium"
                      }
                      id="icon-switch"
                    />
                  )}
                </NavbarText>
              ) : null} */}

              {/* {studentView === false ? ( */}
                <NavbarText className="text-light font-weight-bold mt-2 ml-2">
                  <Button
                    size="sm"
                    style={{ backgroundColor: "#FED700", color: "black" }}
                    onClick={this.logout}
                  >
                    Logout
                  </Button>
                </NavbarText>
              {/* ) : null} */}
            </Nav>
          </Collapse>
        </Navbar>
        {this.state.copied && (
          <div
            style={{
              background: "#bcfda3",
              color: "#4c844c",
              padding: "5px 20px",
            }}
          >
            <label>
              <i className="fas fa-check mr-2"></i> Referral link Copied!
            </label>
          </div>
        )}
      </div>
    );
  }
}

HeaderComponent.propTypes = {
  switchToWhiteLabelView: PropTypes.func.isRequired,
  doLogin: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loginSuccessNormal: state.feedRed.loginSuccessNormal,
});

export default connect(mapStateToProps, {
  switchToWhiteLabelView,
  doLogin,
  getAllAccounts,
  loginUser,
  loginEmTeacher,
})(withRouter(HeaderComponent));
